import { FunctionComponent } from "react";
import Spinner from "@anwb/spinner";

export const LoadingState: FunctionComponent = () => <Spinner message={"Bezig met laden"} />;
